import './LoadingState.css';

const STAGES = [
  'Decoding image bytes',
  'Stage 01 · Authenticity check',
  'Stage 02 · Manipulation analysis',
  'Stage 03 · Factual coherence',
  'Computing credibility index',
];

export default function LoadingState() {
  return (
    <div className="loading-state">
      <div className="loading-state__box">
        <div className="panel-label">
          <span>ANALYSIS IN PROGRESS</span>
          <span className="panel-label__sub">~6S AVG</span>
        </div>
        <div className="loading-state__stages">
          {STAGES.map((s, i) => (
            <div
              key={i}
              className="loading-state__row"
              style={{ animationDelay: `${i * 0.25}s` }}
            >
              <span className="loading-state__dot">●</span>
              <span>{s}</span>
              <span className="loading-state__dots">···</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
